import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

// Early detection for survey mode based on URL path
const pathname = window.location.pathname;
const pathSegments = pathname.split('/').filter(Boolean);
const isSurveyMode = pathSegments.length >= 2 && pathSegments[0] === 'patient-survey';

const root = ReactDOM.createRoot(document.getElementById('root'));

if (isSurveyMode) {
    // Load lightweight survey app - no Redux, no MSAL, minimal dependencies
    import('./SurveyApp').then(({ SurveyApp }) => {
        root.render(<SurveyApp />);
    });
} else {
    // Load full enterprise application with all features
    Promise.all([
        import('./App'),
        import('react-redux'),
        import('./store'),
        import('react-router-dom'),
        import('@azure/msal-react'),
        import('@azure/msal-browser'),
        import('./azure_auth/authConfig')
    ]).then(([
        { default: App },
        { Provider },
        { store },
        { createBrowserRouter, RouterProvider },
        { MsalProvider },
        { PublicClientApplication },
        { msalConfig }
    ]) => {
        const router = createBrowserRouter([
            { path: "*", element: <App /> }
        ]);

        let msalInstance;
        try {
            msalInstance = new PublicClientApplication(msalConfig);
        } catch (error) {
            console.warn("MSAL initialization failed, falling back to internal auth", error);
            msalInstance = null;
        }

        root.render(
            msalInstance ? (
                <MsalProvider instance={msalInstance}>
                    <Provider store={store}>
                        <RouterProvider router={router} />
                    </Provider>
                </MsalProvider>
            ) : (
                <Provider store={store}>
                    <RouterProvider router={router} />
                </Provider>
            )
        );
    });
}

reportWebVitals();